// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import { CollectionItemsSlug } from 'mobile_web/modules/navigation/routes'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { getComponentParams } from '../../home/functions'
import CollectionItemsComponent from '../components/CollectionItems'

type CollectionItemsRouteParams = RouteComponentProps<{
	id?: string
	locale?: string
	tabIndex?: string
	type?: CollectionItemsSlug
}>

const CollectionItemsRoute: FC<CollectionItemsRouteParams> = ({ match: { params }, location: { state } }) => {
	const { id, version, collectionAccountId, accountId } = getComponentParams(params.type, params, state)

	return (
		<CollectionItemsComponent
			collectionId={id}
			collectionVersion={version}
			collectionTitle=""
			collectionAccountId={collectionAccountId}
			accountId={accountId}
		/>
	)
}

export default WithContainerRoute(CollectionItemsRoute)
